<template lang="pug">
  v-layout
    v-flex(xs3) {{ label }}:
    v-flex {{ value ? value : '-' }}
</template>

<script>
export default {
  name: "card-row-label-value",

  props: {
    label: String,
    value: String
  }
}
</script>